'use client';

import { buildBreadcrumbManager } from '@coveo/atomic-react';
import { useController } from '@lib/hooks/useController';
import { useCallback, useMemo } from 'react';
import { useEngine } from '../EngineContext';
import { FacetBreadcrumbsProps } from './FacetBreadcrumbs.types';
import { FacetBreadcrumbsControl } from './FacetBreadcrumbsControl';

export const FacetBreadcrumbs = ({ className }: FacetBreadcrumbsProps) => {
  const eng = useEngine();
  const controller = useMemo(() => buildBreadcrumbManager(eng), [eng]);
  const state = useController(controller);

  const handleDeselectAll = useCallback(
    () => controller.deselectAll(),
    [controller]
  );

  return (
    <FacetBreadcrumbsControl
      state={state}
      onDeselectAll={handleDeselectAll}
      className={className}
    />
  );
};
